export default __webpack_public_path__ + "static/media/Sign-up-Dark-personal.e3556779.svg";